angular.module 'zc.core'

.filter "dayOfWeek", ($filter) ->
  (day) ->
    date = moment().day(day).toDate()
    $filter('date')(date, 'EEEE')



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/day_of_week.js.coffee